import React from 'react'
import PropTypes from 'prop-types'
import Card from '../Card/Card'
import Hero from '../Hero/Hero'
import styles from '../Card/_card.css'
import convert from 'shared/units/convert'

import icons from './communityIcons'
import backgrounds from './communityBackgrounds'

export default function CommunityYearInReview (props) {
  const {
    activateStatCard,
    activeCards,
    isLoggedIn,
    userCountry,
    userUnitPreference,
    userYear,
    year,
  } = props

  const hideWaypoint = isLoggedIn && !userYear
  const isImperial = userUnitPreference === 'imperial' || !isLoggedIn

  const totalMiles = 824040913
  const totalKm = convert(totalMiles).from('mile').to('kilometer')
  const totalTrips = 256602
  const totalWorkouts = 223293042
  const totalHours = 179596163
  const totalYears = totalHours / 365 / 24
  const empireStateBuildingYearlyConsumption = 12869569790 // calPerYear
  const empireStateBuildingDailyConsumption = empireStateBuildingYearlyConsumption / 365
  const totalCalories = 92762178725
  const totalDaysOfEnergy = parseInt(totalCalories / empireStateBuildingDailyConsumption, 10)
  const totalRoutes = 160936847
  const totalRoutesPerDay = totalRoutes / 365

  return (
    <div className={styles.communityCards}>
      <Hero
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        hideWaypoint={hideWaypoint}
        id='community-hero'
        isLoggedIn={isLoggedIn}
        location='community'
        userCountry={userCountry}
        year={year}
      />
      <Card
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        id={isImperial ? 'communityDistanceImperial' : 'communityDistanceMetric'}
        background={ backgrounds.distance }
        stat={
          {
            number: isImperial ? totalMiles : totalKm,
            captionValue: totalTrips,
          }
        }
        comparison={
          {
            gradient: icons.distanceGradient,
            value: totalTrips,
          }
        }
      />
      <Card
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        id='communityWorkouts'
        stat={
          {
            number: totalWorkouts,
            captionValue: 'Mexico',
          }
        }
        comparison={
          {
            gradient: icons.workoutsGradient,
            light: icons.workoutsLight,
            value: 'Mexico\'s',
          }
        }
      />
      <Card
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        id='communityDuration'
        background={ backgrounds.duration }
        stat={
          {
            number: totalHours,
            captionValue: totalYears,
          }
        }
        comparison={
          {
            gradient: icons.durationGradient,
            value: totalYears,
          }
        }
      />
      <Card
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        id='communityEnergy'
        stat={
          {
            number: totalCalories,
            captionValue: totalDaysOfEnergy,
          }
        }
        comparison={
          {
            gradient: icons.energyGradient,
            light: icons.energyLight,
            value: totalDaysOfEnergy,
          }
        }
      />
      <Card
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        id='communityRoutes'
        background={ backgrounds.routes }
        stat={
          {
            number: totalRoutes,
            captionValue: `${parseInt(totalRoutesPerDay / 1000, 10)}k`,
          }
        }
        comparison={
          {
            gradient: icons.routesGradient,
            value: totalRoutesPerDay,
          }
        }
      />
    </div>
  )
}

CommunityYearInReview.propTypes = {
  userYear: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  userUnitPreference: PropTypes.string,
  year: PropTypes.string,
  userCountry: PropTypes.string,
  activeCards: PropTypes.array,
  activateStatCard: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Community/Community.jsx